import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "dss-shared-lib-restriction-pdf-download-confirmation",
    templateUrl: "./restriction-pdf-download-confirmation.component.html",
    styleUrls: ["./restriction-pdf-download-confirmation.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RestrictionPdfDownloadConfirmationComponent {}
